module.exports = __webpack_public_path__ + "img/emptycart.353a9f1d.png";